import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./ServicesInterviewPrepData.css"; // Standard custom styling loaded here
import ServiceCard from "../../Career_Solutions/ServiceSection/ServiceCard/ServiceCard";

const interviewPrepData = [
  {
    id: 1,
    title: "Interview Preparation",
    description: "Master your next job interview with our detailed Q&A guide.",
    features: [
      "Explore 150+ job profiles to find your pick",
      "Access 20,000+ questions with sample answers'",
    ],
    price: "499",
    imageSrc:
      "/assets/Images/career_solutions/HighlightServices/interview-prep-student.svg",
    baseLink: "/career-booster",
  },
];

const ServicesInterviewPrepData = () => {
  return (
    <div className="services-showcase-parent ">
      <Container className="">
        <Row className="g-4">
          {interviewPrepData.map((service) => (
            <Col key={service.id} xl={12} xs={12}>
              <ServiceCard
                baseLink={service.baseLink}
                title={service.title}
                description={service.description}
                features={service.features}
                price={service.price}
                imageSrc={service.imageSrc}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default ServicesInterviewPrepData;
